// Page designs available for Landmark dynamic events (VIP dinners etc).
//
// Must stay in sync with:
//   events-client/src/EventsDynamic/designs/index.js   (the components)
//   blocks-backend/controllers/landmark/dynamicEventManager.js KNOWN_DESIGN_IDS
//
// Thumbnails are screenshots of each design rendered with a sample event.
import thumbOriginal from "../../../../images/dynamic-event-designs/original.jpg";
import thumbCover from "../../../../images/dynamic-event-designs/cover.jpg";

export const DYNAMIC_EVENT_DESIGNS = [
  {
    id: "original",
    name: "Original",
    description:
      "Two-column page: hero copy on the left, sticky event details card on the right, RSVP opens in a modal.",
    thumbnail: thumbOriginal,
  },
  {
    id: "cover",
    name: "Cover",
    description:
      "Full-screen venue photo with the registration form on the cover, date / address / agenda strip, about + FAQs, photo reel.",
    thumbnail: thumbCover,
  },
];

export const DEFAULT_DESIGN_ID = "original";

// Settings that only the Cover design reads (stored at event.design.options.cover)
export const DEFAULT_COVER_OPTIONS = {
  showLandmarkHeaderText: true, // "with Landmark Ventures" top-left of the cover
  showLandmarkFooterText: true, // "with Landmark Ventures" bottom-left in the footer
};

export const normalizeCoverOptions = (options) => ({
  showLandmarkHeaderText: options?.showLandmarkHeaderText !== false,
  showLandmarkFooterText: options?.showLandmarkFooterText !== false,
});

export const getDesignById = (id) =>
  DYNAMIC_EVENT_DESIGNS.find((d) => d.id === `${id || ""}`.toLowerCase().trim()) ||
  null;

export const getDesignName = (id) => getDesignById(id)?.name || id || "Original";

// Normalise whatever is stored on the event into the shape the form uses.
export const normalizeDesignFromEvent = (event) => {
  const design = event?.design || {};
  const designId = getDesignById(design.designId)?.id || DEFAULT_DESIGN_ID;
  const abTestEnabled = !!design?.abTest?.enabled;
  const abTestDesignIds = Array.isArray(design?.abTest?.designIds)
    ? design.abTest.designIds.filter((id) => getDesignById(id))
    : [];
  return {
    designId,
    abTestEnabled,
    abTestDesignIds: abTestDesignIds.length
      ? Array.from(new Set(abTestDesignIds))
      : DYNAMIC_EVENT_DESIGNS.map((d) => d.id),
    coverOptions: normalizeCoverOptions(design?.options?.cover),
  };
};

// Where the public site lives. Override locally with REACT_APP_EVENTS_CLIENT_URL
// (e.g. http://localhost:3100) to preview against a dev build of events-client.
export const EVENTS_CLIENT_URL = (
  process.env.REACT_APP_EVENTS_CLIENT_URL || "https://events.landmarkventures.com"
).replace(/\/+$/, "");

export const PUBLIC_EVENTS_HOST = "https://events.landmarkventures.com";

// How many events the dashboard lists show before "Show more events".
export const EVENTS_PAGE_SIZE = 30;
